import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
  },

  readerHide: {
    display: 'none',
  },

  filename: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightMedium,
    marginLeft: 8,
  },

  uploadTextContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    left: '25%',
    position: 'absolute',
    top: '15%',
  },

  csvDescription: {
    display: 'block',
    fontSize: theme.typography.pxToRem(13),
  },

  csvMaxRows: {
    display: 'block',
    fontSize: theme.typography.pxToRem(13),
    marginLeft: 10,
    marginTop: 10,
    marginBottom: 24,
  },

  uploadIcon: {
    color: theme.palette.common.gray,
    fontSize: theme.typography.pxToRem(26),
  },

  uploadText: {
    color: theme.palette.common.gray,
    fontSize: theme.typography.pxToRem(13),
    marginTop: 20,
  },

  browse: {
    cursor: 'pointer',
    marginLeft: 2,
    textDecoration: 'underline',
  },

  downloadContainer: {
    backgroundColor: '#F56A000A',
    border: '1px solid #F56A0019',
    borderRadius: 4,
    display: 'flex',
    marginTop: 24,
    padding: 15,
  },

  downloadIcon: {
    color: '#F56A00',
    marginRight: 10,
  },

  downloadLink: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontWeight: 500,
    marginLeft: 2,
    '&:hover': {
      fontWeight: 500,
    },
  },

  buttonContainers: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 15,
  },

  inlineAction: {
    fontWeight: 500,
    textTransform: 'none',
  },

  fileName: {
    color: theme.palette.text.subtitle,
    marginLeft: '6px',
    maxWidth: '100%',
    paddingRight: 30,
  },

  successIcon: {
    color: theme.palette.success.main,
  },

  errorIcon: {
    color: theme.palette.error.main,
  },

  fieldText: {
    fontSize: theme.typography.pxToRem(13),
    marginLeft: 5,
  },

  field: {
    background: '#F4F5F7',
    borderRadius: 2,
    fontSize: theme.typography.pxToRem(13),
    letterSpacing: 1.5,
    padding: '0 4px',
  },
}));

export default useStyles;
